import styles from "./ScheduleInstructorInfoPopup.module.scss";
import React from "react";
import closePopupIcon from "../../../assets/images/icons/close-pupup-dark.svg";
import {IClassEvent, IClassEventPublic} from "../../../models/ClassEvent";
import {getProfileImageByString} from "../../../helpers/image.helper";
import useDisableScroll from "../../../hooks/useDisableScroll";
import useAppSelector from "../../../hooks/useAppSelector";


interface ScheduleInstructorPopupProps {
    classEvent: IClassEvent | IClassEventPublic;
    closePopup: () => void;
}

const ScheduleInstructorPopup: React.FC<ScheduleInstructorPopupProps> = ({classEvent, closePopup}) => {
    useDisableScroll();

    const {activeGym} = useAppSelector(state => state.multiGymsSlice);

    return (
        <div className={styles.container}>
            <div className={styles.popup}>
                <img onClick={closePopup} className={styles.close} src={closePopupIcon} alt={"close"}/>
                <div className={styles.profileImage} style={{backgroundImage: `url(${getProfileImageByString(activeGym.endpoint, classEvent.instructorProfileImage)})`}}></div>
                <h4 className={styles.name}>{classEvent.instructorFirstName} {classEvent.instructorLastName}</h4>
                <p className={styles.bio}>{classEvent.instructorBio}</p>
            </div>
        </div>
    )

}

export default ScheduleInstructorPopup;